import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { HEADER } from 'utils/sectionTypes';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import { editModal } from '../decorators';
import { compose } from '../../../utils/react';
import useCurrentPage from '../../../../../website/hooks/useCurrentPage';
import Radio from '../../form/inputs/Radio/Radio';
import styles from './HeaderLogoNav.scss';
import Field from '../../../../../modules/react/components/stateful/Field';

const propTypes = {
  children: PropTypes.node.isRequired,
};
const defaultProps = {};

const BACKGROUND_STYLE = 'backgroundStyle';

const HeaderLogoNav = ({ children, backgroundStyle }) => {
  const [headerLogo, nav] = React.Children.toArray(children);
  const { primaryColorBackgroundClass } = useCurrentPage();
  const isInverse = backgroundStyle === 'inverse';

  return (
    <div className={cx('pb-no-click', styles.container, { [primaryColorBackgroundClass]: isInverse })}>
      <div className={styles.imageContainer}>
        {React.cloneElement(headerLogo, { className: styles.image })}
      </div>
      <div />
      <div className={styles.navContainer}>{React.cloneElement(nav, { inverseBackground: isInverse })}</div>
    </div>
  );
};

HeaderLogoNav.propTypes = propTypes;
HeaderLogoNav.defaultProps = defaultProps;

const backgroundOptions = {
  standard: 'Standard',
  inverse: 'Inverse',
};

const tooltips = {
  standard: 'White background with primary color buttons',
  inverse: 'Primary color background with white buttons',
};

const component = compose(
  editModal(
    props => ({
      title: 'Edit Header Section',
      initialValues: { [BACKGROUND_STYLE]: props[BACKGROUND_STYLE] || 'standard' },
    }),
    [{
      children: (
        <Field
          label="Header Background Styles"
          name={BACKGROUND_STYLE}
          component={Radio}
          options={backgroundOptions}
          tooltips={tooltips}
        />
      ),
    }],
  ),
  section(
    {
      name: 'Header: Logo and Nav',
      region: HEADER,
      category: 'Header / Navigation',
    },
    {
      subsections: [{ accepts: 'HeaderLogo' }, { accepts: 'NavigationV2' }],
      defaults: ['HeaderLogo', 'NavigationV2'],
      hideLabel: true,
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(HeaderLogoNav);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
